<template>
  <div class="row">
    <div class="col-12">
      <card :title="table1.title" :subTitle="table1.subTitle">
        <div slot="raw-content" class="table-responsive">
          <paper-table :data="table1.data" :columns="table1.columns">
          </paper-table>
        </div>
      </card>
    </div>

    <!-- <div class="col-12">
        <card class="card-plain">
          <div class="table-full-width table-responsive">
            <paper-table type="hover" :title="table2.title" :sub-title="table2.subTitle" :data="table2.data"
                         :columns="table2.columns">

            </paper-table>
          </div>
        </card>
      </div> -->
  </div>
</template>
<script>
import { EventBus } from "@/event-bus";
import { PaperTable } from "@/components";
const tableColumns = ["ARTWORK_PATH", "REFERENCE_ID", "PRODUCT_NAME", "SKUs", "QTY", "ACTION"];

export default {
  components: {
    PaperTable,
  },
  data() {
    return {
      table1: {
        title: "Orders to Reprint",
        columns: [...tableColumns],
        data: [],
      },
    };
  },
  mounted: function (event) {
    const self = this;
    const addToListHandler = function (order) {
      console.log("orderinside list: " + JSON.stringify(order));
      self.table1.data.push(order.items);
    };
    EventBus.$on("eventing", addToListHandler);
  },
};
</script>
<style>
</style>
